import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function EditPencil({
  className,
  fillPrimary = colors.blue40,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[16px] w-[17px]', className)}
    >
      <path
        d="M3.86426 14.9546L1.56494 15.8262C1.38232 15.8926 1.21354 15.8511 1.05859 15.7017C0.903646 15.5578 0.864909 15.3835 0.942383 15.1787L1.80566 12.9043L12.0156 2.68604L14.0742 4.73633L3.86426 14.9546ZM15.0786 3.74023L13.02 1.68994L14.1074 0.61084C14.3675 0.350749 14.6442 0.212402 14.9375 0.195801C15.2363 0.179199 15.5075 0.298177 15.751 0.552734L16.2158 1.01758C16.4648 1.2666 16.5838 1.53776 16.5728 1.83105C16.5672 2.11882 16.4316 2.39274 16.166 2.65283L15.0786 3.74023Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
